<template>
  <div
      class="title"
      :style="{ backgroundImage: `url(${wave})` }"
  >
    <div class="container">
      <h1>{{ title }}</h1>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  title: String,
  wave: String
})
</script>

<style lang="scss" scoped>
.title {
  background-color: #F3FAFD;
  background-repeat: no-repeat;
  -webkit-background-size: cover;
  background-size: cover;
  background-position: center;
  height: 240px;
  display: flex;
  align-items: flex-end;

  & h1 {
    position: relative;
    z-index: 1;
    //max-width: 500px;

    font-family: Syne, sans-serif;
    font-size: 50px;
    font-weight: 700;
    background: linear-gradient(90deg, #FF85FD 0.5%, #7D045A 44.83%, #3D2B44 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
}

.container {
  width: 100%;
  position: relative;
  bottom: 40px;
  left: 0;
}

@media (max-width: 1400px) {
  .title {
    -webkit-background-size: cover;
    background-size: cover;
  }
}

@media (max-width: 1300px) {
  .title {
    & h1 {
      font-size: 40px;
    }
  }

  .container {
    width: 90%;
  }
}
</style>